import {AccountContext} from '../../utils/Context';
import If from '../utils/If';
import React from 'react';

export default function OldLogo() {
  return (
    <div className="mb-10">
      <AccountContext.Consumer>
        {account =>
          <>
            <If condition={!!account?.image}>
              <img src={account?.image} className="w-32"/>
            </If>
            <If condition={!account?.image}>
              <div className="border-blue border w-28 h-28 text-blue flex flex-col place-content-center text-center">
                <strong>No logo</strong>
              </div>
            </If>
            <div className="text-gray-dark text-xl font-bold mt-3">{account?.name}</div>
          </>
        }
      </AccountContext.Consumer>
    </div>
  )
}
